import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2daedab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-title" }

import { ref, nextTick, watch, onMounted } from 'vue'
import store from "@/store";
import { useRouter, useRoute } from 'vue-router'
// import { getHelpAllCategory }  from '@/api/help-center'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const menus = ref<IHelpCategory[]>([])
// 这里去获取的类型的第一个即可
const defaultActive = ref('')

const getHelpCenterAllCategory = async(mid: string) => {
  const id = route.params.id || route.query.id
  // 标记当前 分类ID 是否存在
  let hasCategoryId: boolean = false
  
  try {  
    const r = await store.dispatch('setHelpCategorys', mid)

    menus.value = r.map((c: IHelpCategory) => {
      if(!hasCategoryId && Number(id) === c.id) {
        hasCategoryId = true
      }

      if(c.children && c.children.length > 0) {
        c.children.forEach(element => {
          if(!hasCategoryId && Number(id) === element.id) {
            hasCategoryId = true
          }
          element.path = `/help-center/${mid}/${element.id}`
        })
      }

      c.path = `/help-center/${mid}/${c.id}`
      return c
    })
    await nextTick()

    let actPath: string = `/help-center/${mid}/${id}`

    if(!id || !hasCategoryId) {
      actPath = menus.value[0].children && menus.value[0].children.length > 0
        ? String(menus.value[0].children[0].path)
        : String(menus.value[0].path)
    }
    
    route.name === 'HelpCenter' && router.push(actPath)

    await nextTick()
    defaultActive.value = actPath
    console.log("🚀 ~ init ~ defaultActive.value:", defaultActive.value)
  } catch(err) {
    console.error(err)
  }
}

let moduleId: string
const init = async() => {
  const mid = route.params.mid || route.query.mid

  if(!mid || mid === moduleId) {
    return
  }
  moduleId = mid as string
  await getHelpCenterAllCategory(mid as string)
}
watch(
  () => route.params.mid,
  init
)
onMounted(init)

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": defaultActive.value,
    "unique-opened": true,
    class: "el-menu-vertical-demo",
    router: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (menu1) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (menu1.children && menu1.children.length > 0)
            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: menu1.id,
                index: menu1.path,
                "data-path": menu1.path
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(menu1.title), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu1.children, (menu2) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: menu2.id,
                      index: menu2.path,
                      "data-path": menu2.path
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menu2.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["index", "data-path"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["index", "data-path"]))
            : (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                "data-path": menu1.path,
                index: menu1.path,
                class: "menu-title"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(menu1.title), 1)
                ]),
                _: 2
              }, 1032, ["data-path", "index"]))
        ], 64))
      }), 256))
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})